import React from "react";
import {observer} from "mobx-react-lite";
import Drawer from "@mui/material/Drawer";
import {useStores} from "../../../stores";
import {styled} from "@mui/material/styles";
import IconButton from "@mui/material/IconButton/IconButton";
import {ChevronRightIcon} from "@radix-ui/react-icons";
import Divider from "@mui/material/Divider";
import {List, ListItem, ListItemButton, ListItemText} from "@mui/material";
import {generatePath, useNavigate} from "react-router";
import {routes} from "../../../routing/routes";
import {sitRoutes} from "../../../sit/routing/sitRoutes";

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export const DevopsMenu: React.FC = observer(() => {
    const {authStore, rootAppStore} = useStores();
    const navigate = useNavigate();

    const handleLinkClick = (path: string) => {
        navigate(path);
        rootAppStore.setIsDevopsMenuOpen(false);
    }

    if (!authStore.isMithraStaffGroup) {
        return <></>;
    }

    return <Drawer
        anchor="right"
        hideBackdrop
        variant="persistent"
        open={rootAppStore.isDevopsMenuOpen}
        onClose={() => rootAppStore.setIsDevopsMenuOpen(false)}>
        <DrawerHeader>
            <IconButton onClick={() => rootAppStore.setIsDevopsMenuOpen(false)}>
                <ChevronRightIcon/>
            </IconButton>
        </DrawerHeader>

        <Divider/>
        <List>
            <ListItem disablePadding>
                <ListItemButton onClick={() => handleLinkClick(generatePath(routes.data_ingestion))}>
                    <ListItemText primary="Data Ingestion"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton onClick={() => handleLinkClick(generatePath(routes.taxonomy_ingestion))}>
                    <ListItemText primary="Taxonomy Ingestion"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton onClick={() => handleLinkClick(generatePath(sitRoutes.sit_initiatives))}>
                    <ListItemText primary="Initiative Tracker"/>
                </ListItemButton>
            </ListItem>

            {/*<ListItem disablePadding>*/}
            {/*    <ListItemButton>*/}
            {/*        <ListItemIcon>*/}
            {/*            <Home/>*/}
            {/*        </ListItemIcon>*/}
            {/*        <ListItemText primary="home"/>*/}
            {/*    </ListItemButton>*/}
            {/*</ListItem>*/}

        </List>

    </Drawer>
})